export default () => ({
  duration: 0,
});
